"use client";
import o from "./index.es141.js";
import t from "react";
import { createNumberFormatter as d, isNumber as f } from "./index.es82.js";
const b = o.div`
  margin-bottom: 1rem;
`, p = o.div`
  overflow-x: auto;
  position: relative;
`, u = o.table`
  caption {
    display: none;
  }
  thead {
    th:not(:first-child) {
      background-color: #fff;
    }
  }
  tbody {
    background-color: #fff;
    & tr > th:first-child {
      background: #fff;
    }
  }
  & tr > th:first-child {
    position: sticky;
    left: 0;
  }
  td {
    text-align: right;
    color: #000;
  }
`, k = ({
  chartdata: c,
  parentId: l,
  isDecimal: n,
  caption: i
}) => {
  const s = d(n);
  return /* @__PURE__ */ t.createElement(b, null, /* @__PURE__ */ t.createElement(p, { className: "bl-m-y-3" }, /* @__PURE__ */ t.createElement(u, { className: "bl-table bl-table--striped" }, /* @__PURE__ */ t.createElement("caption", null, i), /* @__PURE__ */ t.createElement("thead", null, /* @__PURE__ */ t.createElement("tr", null, /* @__PURE__ */ t.createElement("th", null), c.labels.map((e, a) => /* @__PURE__ */ t.createElement(
    "th",
    {
      scope: "col",
      key: `statistics-table-header-${l}-${a}`
    },
    e
  )))), /* @__PURE__ */ t.createElement("tbody", null, c.datasets.map((e, a) => /* @__PURE__ */ t.createElement("tr", { key: `statistics-table-row-${l}-${a}` }, /* @__PURE__ */ t.createElement("th", { scope: "row" }, e.label), e.data.map((r, m) => /* @__PURE__ */ t.createElement(
    "td",
    {
      key: `statistics-table-cell-${l}-${a}-${m}`
    },
    f(r) ? s(r) : r
  ))))))));
};
export {
  k as default
};
//# sourceMappingURL=index.es93.js.map
